import styled, { css } from "styled-components";

interface IDropdownProps {
  isOpen: boolean;
  position?: "top" | "bottom";
  variant?: "transparent" | "solid";
}

export const Container = styled.div<{ variant?: "transparent" | "solid" }>`
  position: relative;
  width: fit-content;
  user-select: none;
  font-family: "Segoe UI Emoji", "Apple Color Emoji", "Noto Color Emoji", sans-serif;

  ${({ variant }) =>
    variant === "transparent"
      ? css`
          background-color: rgba(255, 255, 255, 0.3);
          border: 4px solid rgba(255, 255, 255, 0);
          color: var(--white);
          font-size: 17px;
          border-radius: 6px;
        `
      : css`
          background-color: var(--background);
          border: 1px solid var(--gray);
          color: var(--gray);
          font-size: 12px;
          border-radius: 15px;
          padding: 2px 5px;

          &:hover {
            color: var(--fixit);
            border-color: var(--fixit);
          }
        `}
`;

export const SelectedValue = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  cursor: pointer;
  padding: 4px 8px;
`;

export const DropdownList = styled.ul<IDropdownProps>`
  position: absolute;
  ${({ position }) => (position === "top" ? "bottom: 110%;" : "top: 110%;")}
  left: 0;
  margin: 0;
  padding: 0;
  list-style: none;
  background-color: var(--white);
  border: 1px solid var(--light-gray);
  border-radius: 8px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  min-width: 100%;
  z-index: 100;
  display: ${({ isOpen }) => (isOpen ? "flex" : "none")};
  flex-direction: column;
  overflow: hidden;
`;

export const ListItem = styled.li<{ isSelected: boolean }>`
  padding: 8px 12px;
  cursor: pointer;
  color: var(--dark-gray);
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;

  ${({ isSelected }) =>
    isSelected &&
    css`
      background-color: var(--light-gray);
      font-weight: 600;
    `}

  &:hover {
    background-color: #f0f0f0;
  }
`;
